export default __webpack_public_path__ + "static/media/dental-checkup.e95aa605.png";